module.exports = __webpack_public_path__ + "img/paypal.c9bfb215.svg";